import React from 'react'
import Heading from '../Heading'

import { motion } from "framer-motion";
import {  support } from '../../Data/E_Offer';
const Support = () => {
     const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
                duration: 0.8
            }
        }
    };
  return (
        <motion.section 
            className="main-lwbl bg-[#F9FAFB] pt-16 pb-16 px-[0.5rem] overflow-hidden"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-50px" }}
            variants={containerVariants}
        >
           <Heading subHeading={"Simple, intentional ways to start connecting"}
             heading={"Your Path Into the Community"}
             detail={"Becoming part of the Lightweave community is a welcoming and easy process. Whether you start by posting your first showcase, joining a discussion, or participating in a challenge, every step brings you closer to a supportive network of creative peers."}
           />

           <div className='flex flex-wrap justify-center items-center gap-[20px] mt-[3rem]'>
              {support.map((data,index)=>(
                 
                 <div
        className="group relative w-[290px] xs:w-[100%] h-[200px] flex flex-col items-center justify-center text-center gap-[1rem] rounded-2xl px-[0.8rem] py-[1rem] 
          transition-all duration-500 hover:scale-[1.04] 
          hover:-translate-y-2 hover:shadow-xl"
        style={{
          background:
            "linear-gradient(29deg, rgba(0, 240, 251, 1) 0%, rgba(255,255,255,1) 50%, rgba(0, 240, 251, 1) 100%)",
        }}
      > 
        <h2
          className="font-cinzel text-[24px] pt-2 pb-2 font-medium 
            transition-all duration-500 group-hover:tracking-wide"
        >
          {data.title}
        </h2>
        
      </div>
              ))}
           </div>
       </motion.section>
  )
}

export default Support;